import styled from 'styled-components';

const LibraryBooklistTabletBody = styled.tbody`
	text-align: center;
	color: #242a37;
`;

export default LibraryBooklistTabletBody;
